import { render } from "./LoadingRadioGroup.vue?vue&type=template&id=aaa6df76"
import script from "./LoadingRadioGroup.vue?vue&type=script&lang=js"
export * from "./LoadingRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__